import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject } from 'rxjs';




@Injectable({
  providedIn: 'root'
})
export class DirectionService {
  private directionSubject = new BehaviorSubject<'ltr' | 'rtl'>('ltr');
  direction$ = this.directionSubject.asObservable();

  getCurrentDirection(): 'ltr' | 'rtl' {
    return this.directionSubject.value;
  }

  constructor() {
    const dir = localStorage.getItem('dir');
    this.updateHtmlDir(dir as 'rtl' | 'ltr');
  }

  setCurrentDir() {

    const dir = localStorage.getItem('dir');

    const browserLang = navigator.language.startsWith('ar') ? 'rtl' : 'ltr'

    this.directionSubject.next(dir || browserLang as any)
  }
  setDirection(direction: 'ltr' | 'rtl') {
    this.directionSubject.next(direction);
    localStorage.setItem('dir', direction);
    this.updateHtmlDir(direction);
  }


  private updateHtmlDir(direction: 'ltr' | 'rtl') {
    document.documentElement.setAttribute('dir', direction);
    document.body.setAttribute('dir', direction);
  }

}
